export var languageNames = {
  'af': 'Afrikaans',
  'ak': 'Akan',
  'am': 'አማርኛ',
  'ar': 'العربية',
  'az': 'azərbaycan',
  'be': 'беларуская',
  'bg': 'български',
  'bm': 'bamanakan',
  'bn': 'বাংলা',
  'bo': 'བོད་སྐད་',
  'br': 'brezhoneg',
  'bs': 'bosanski',
  'ca': 'català',
  'cs': 'čeština',
  'cy': 'Cymraeg',
  'da': 'dansk',
  'de': 'Deutsch',
  'dz': 'རྫོང་ཁ',
  'ee': 'eʋegbe',
  'el': 'Ελληνικά',
  'en': 'English',
  'eo': 'esperanto',
  'es': 'español',
  'et': 'eesti',
  'eu': 'euskara',
  'fa': 'فارسی',
  'ff': 'Pulaar',
  'fi': 'suomi',
  'fo': 'føroyskt',
  'fr': 'français',
  'fy': 'West-Frysk',
  'ga': 'Gaeilge',
  'gd': 'Gàidhlig',
  'gl': 'galego',
  'gu': 'ગુજરાતી',
  'ha': 'Hausa',
  'he': 'עברית',
  'hi': 'हिंदी',
  'hr': 'hrvatski',
  'hu': 'magyar',
  'hy': 'հայերեն',
  'ia': 'interlingua',
  'id': 'Bahasa Indonesia',
  'ig': 'Igbo',
  'is': 'íslenska',
  'it': 'italiano',
  'ja': '日本語',
  'ka': 'ქართული',
  'ki': 'Gikuyu',
  'kk': 'қазақ тілі',
  'kl': 'kalaallisut',
  'km': 'ខ្មែរ',
  'kn': 'ಕನ್ನಡ',
  'ko': '한국어',
  'ks': 'کٲشُر',
  'kw': 'kernewek',
  'ky': 'кыргызча',
  'lb': 'Lëtzebuergesch',
  'lg': 'Luganda',
  'ln': 'lingála',
  'lo': 'ລາວ',
  'lt': 'lietuvių',
  'lu': 'Tshiluba',
  'lv': 'latviešu',
  'mg': 'Malagasy',
  'mk': 'македонски',
  'ml': 'മലയാളം',
  'mn': 'монгол',
  'mr': 'मराठी',
  'ms': 'Bahasa Melayu',
  'mt': 'Malti',
  'my': 'ဗမာ',
  'nb': 'norsk bokmål',
  'nd': 'isiNdebele',
  'ne': 'नेपाली',
  'nl': 'Nederlands',
  'nn': 'nynorsk',
  'om': 'Oromoo',
  'or': 'ଓଡ଼ିଆ',
  'os': 'ирон',
  'pa': 'ਪੰਜਾਬੀ',
  'pl': 'polski',
  'ps': 'پښتو',
  'pt': 'português',
  'qu': 'Runasimi',
  'rm': 'rumantsch',
  'rn': 'Ikirundi',
  'ro': 'română',
  'ru': 'русский',
  'rw': 'Kinyarwanda',
  'se': 'davvisámegiella',
  'sg': 'Sängö',
  'si': 'සිංහල',
  'sk': 'slovenčina',
  'sl': 'slovenščina',
  'sn': 'chiShona',
  'so': 'Soomaali',
  'sq': 'shqip',
  'sr': 'српски',
  'sv': 'svenska',
  'sw': 'Kiswahili',
  'ta': 'தமிழ்',
  'te': 'తెలుగు',
  'th': 'ไทย',
  'ti': 'ትግርኛ',
  'tn': 'Setswana',
  'to': 'lea fakatonga',
  'tr': 'Türkçe',
  'ts': 'Xitsonga',
  'ug': 'ئۇيغۇرچە',
  'uk': 'українська',
  'ur': 'اردو',
  'uz': 'oʻzbekcha',
  'vi': 'Tiếng Việt',
  'yi': 'ייִדיש',
  'yo': 'Èdè Yorùbá',
  'zh': '中文',
  'zu': 'isiZulu'
};